import { Button } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import CourseAssignmentContext from "../../context/500/CourseAssignmentContext";
import NewOutOfBatch from "./NewOutOfBatch";
import OffBatchComponent from "./OffBatchComponent";
import OffBatchCourseComponent from "./OffBatchCourseComponent";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";

function OutOfBatch() {
  let [selectedBatch, setSelectedBatch] = useState([]);
  let [selectedCourse, setSelectedCourse] = useState([]);
  let [newBatch, setnewBatch] = useState(false);
  let [admissionfilter, setadmissionfilter] = useState([]);
  let [programfilter, setprogramfilter] = useState([]);

  let { setError, setVal, setsuccess } = useContext(CourseAssignmentContext);

  let api = useAxiosPrivate();

  useEffect(() => {
    if (selectedBatch.length > 0) {
      if (
        admissionfilter[0] != selectedBatch[0].admission_type ||
        programfilter != selectedBatch[0].program_type
      ) {
        setSelectedBatch([]);
      }
    }
  }, [selectedCourse]);

  async function handleAdd() {
    if (selectedBatch.length !== 0 && selectedCourse.length !== 0) {
      console.log(selectedBatch, selectedCourse);
      try {
        let resp = await api.post(`/courseallocation/createoffbatch`, {
          curriculum_id: selectedCourse[0].Curriculums[0].id,
          course_code: selectedCourse[0].course_code,
          batch_id: selectedBatch[0].id,
        });

        setSelectedBatch([]);
        setSelectedCourse([]);
        setadmissionfilter([]);
        setprogramfilter([]);

        setsuccess("Off Batch Course Added");
        setVal("ca");
      } catch (error) {
        if (error.response.status == 400) {
          console.log("Off Batch Already exists");

          setError("Off Batch Already exists");
        } else {
          console.log("Error creating batch");

          setError("Error creating batch");
        }
      }
    } else {
      setError("InValid submission");
    }
  }

  return (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          alignITems: "center",
          width: "100%",
        }}
      >
        {newBatch == false && (
          <Button
            variant="contained"
            sx={{ margin: "25px 25px" }}
            onClick={() => {
              setnewBatch(true);
            }}
          >
            Create New Batch
          </Button>
        )}

        {newBatch == true && (
          <Button
            variant="contained"
            sx={{ margin: "25px 25px" }}
            onClick={() => {
              setnewBatch(false);
            }}
          >
            Choose Existing Batch
          </Button>
        )}
      </div>

      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "space-evenly",
          alignItems: "flex-start",
          marginBottom: "30px",
        }}
      >
        {newBatch == false && (
          <OffBatchCourseComponent
            selectedCourse={selectedCourse}
            setSelectedCourse={setSelectedCourse}
            setadmissionfilter={setadmissionfilter}
            setprogramfilter={setprogramfilter}
          />
        )}

        {newBatch == false && (
          <OffBatchComponent
            setSelectedBatch={setSelectedBatch}
            setSelectedCourse={setSelectedCourse}
            programfilter={programfilter}
            setprogramfilter={setprogramfilter}
            admissionfilter={admissionfilter}
            setadmissionfilter={setadmissionfilter}
            selectedBatch={selectedBatch}
          />
        )}

        {newBatch == true && <NewOutOfBatch />}
      </div>

      {newBatch == false && (
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            alignITems: "center",
            width: "100%",
          }}
        >
          <Button
            variant="outlined"
            sx={{ margin: "25px 25px" }}
            onClick={() => {
              setVal("ca");
            }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            sx={{ margin: "25px 25px" }}
            onClick={handleAdd}
          >
            Add
          </Button>
        </div>
      )}
    </>
  );
}

export default OutOfBatch;
